var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21959 2.22898C2.51246 1.93619 2.98721 1.93619 3.28009 2.22898L7.99984 6.94873L12.7196 2.22898C12.9079 2.03402 13.1867 1.95583 13.449 2.02446C13.7112 2.0931 13.916 2.29788 13.9846 2.5601C14.0532 2.82232 13.9751 3.10117 13.7801 3.28948L9.06034 8.00923L13.7801 12.729C14.0643 13.0233 14.0603 13.491 13.771 13.7804C13.4817 14.0697 13.0139 14.0737 12.7196 13.7895L7.99984 9.06973L3.28009 13.7895C2.98581 14.0737 2.51802 14.0697 2.22872 13.7803C1.93942 13.491 1.93536 13.0233 2.21959 12.729L6.93934 8.00923L2.21959 3.28948C1.9268 2.9966 1.9268 2.52185 2.21959 2.22898L2.21959 2.22898Z",
    fill: "#444F59",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.270eeeedd6e8c1e3d1948c7c2cc9849a.svg";
export { ForwardRef as ReactComponent };